import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

// NOTE: We use Authorization Bearer tokens (not cookies) because the platform
// ingress forces Access-Control-Allow-Origin: * which is incompatible with
// `withCredentials`. The backend supports both cookie and Bearer token auth.

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const userToken = localStorage.getItem("session_token");
  if (userToken) config.headers.Authorization = `Bearer ${userToken}`;
  return config;
});

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function wsUrl(path) {
  const url = new URL(BASE);
  url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
  return `${url.origin}${path}`;
}
